import {forwardRef} from "react";
import {Row} from "../Box/Box";
import type {DSTagProps} from "../DSTag/DSTag";
import {DSTag} from "../DSTag/DSTag";

export type DSTagSelectProps<T> = {
  onChange: (value: T) => unknown;
  size?: DSTagProps["size"];
  options: readonly {value: T; label: string}[];
  value?: T[];
  id?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const DSTagSelect = forwardRef<HTMLButtonElement, DSTagSelectProps<any>>((props, ref) => {
  const {onChange, value = [], options, size = "md", id, className, style} = props;
  const valueSet = new Set(value);

  return (
    <Row wrap sp="8px" className={className} style={style}>
      {options.map((o, idx) => (
        <DSTag
          key={o.value}
          size={size}
          onClick={() =>
            onChange?.(
              valueSet.has(o.value) ? value.filter((v: any) => v !== o.value) : [...value, o.value]
            )
          }
          theme={valueSet.has(o.value) ? "active" : "default"}
          ref={idx === 0 ? ref : undefined}
          id={idx === 0 ? id : undefined}
        >
          {o.label}
        </DSTag>
      ))}
    </Row>
  );
});
